interface postWidthToIframeProps {
    iframeRef: React.MutableRefObject<HTMLIFrameElement | null>
    containerRef: React.MutableRefObject<HTMLDivElement | null>
    offset: any
}

export function postWidthToIframe({
    iframeRef,
    containerRef,
    offset,
}: postWidthToIframeProps) {
    const currentIframeRef = iframeRef.current
    const currentContainerRef = containerRef.current

    if (currentIframeRef && currentContainerRef) {
        currentIframeRef.contentWindow?.postMessage(
            {
                frameWidth: currentContainerRef.offsetWidth - offset,
            },
            '*',
        )
    }
}
